import { render, staticRenderFns } from "./BoothPopupEditor.vue?vue&type=template&id=6c8296bb"
import script from "./BoothPopupEditor.vue?vue&type=script&lang=ts"
export * from "./BoothPopupEditor.vue?vue&type=script&lang=ts"
import style0 from "./BoothPopupEditor.vue?vue&type=style&index=0&id=6c8296bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports